/* eslint-disable import/prefer-default-export */

/**
 * Regular expression for validating the TIN (Taxpayer Identification Number) in the United States.
 *
 * This regex covers both Social Security Number (SSN) and Employer Identification Number (EIN) formats:
 * - SSN: Matches the format XXX-XX-XXXX (e.g., 123-45-6789).
 * - EIN: Matches the format XX-XXXXXXX (e.g., 12-3456789).
 *
 * @constant
 * @type {RegExp}
 * @example
 * // Valid SSN example
 * const isValidSSN = USA_TIN_REGEX.test('123-45-6789'); // true
 *
 * @example
 * // Valid EIN example
 * const isValidEIN = USA_TIN_REGEX.test('12-3456789'); // true
 *
 * @example
 * // Invalid example
 * const isInvalid = USA_TIN_REGEX.test('123-456-789'); // false
 */
export const USA_TIN_REGEX = /^\d{3}-\d{2}-\d{4}$|^\d{2}-\d{7}$/;
